import { Box } from '@mui/material';

import Accordion from '../../accordion/accordion';
import Typography from '../../typography/typography';

export interface ITotalSummary {
	total: string | number;
	roundOffDifferenceAmount: number | string;
	currencySymbol: string;
}
interface ITotalSummaryProps {
	data: ITotalSummary;
}

const TotalSummary: React.FC<ITotalSummaryProps> = ({ data }) => {
	return (
		<Accordion
			title={
				<Typography type='s3' weight='medium' color='theme.secondary.1000'>
					Total
				</Typography>
			}
			accordionProps={{
				defaultExpanded: true,
				sx: {
					borderBottomWidth: 1,
					'& .MuiAccordionSummary-root': { borderBottomWidth: 1 }
				}
			}}>
			<Box className='calculationSummary--SummaryContainer'>
				<Box className='calculationSummary--SummaryItem'>
					<Typography type='s5' weight='medium' color='theme.secondary.800'>
						Grand Total
					</Typography>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{data.currencySymbol} {data.total}
					</Typography>
				</Box>
				{Number(data.roundOffDifferenceAmount) > 0 && 
					<Box className='calculationSummary--SummaryItem'>
						<Typography type='s5' weight='medium' color='theme.secondary.800'>
							Round Off Difference
						</Typography>
						<Typography type='s3' weight='medium' color='theme.secondary.1000'>
							{data.currencySymbol} {data.roundOffDifferenceAmount}
						</Typography>
					</Box>
				}
			</Box>
		</Accordion>
	);
};

export default TotalSummary;
